/**
 * Initializes a session and makes a POST request to the API.
 *
 * @param {string} product_id - The ID of the product.
 * @param {string} href - The URL of the vendor.
 * @returns {object} - An object containing the response, error, showModal, setShowModal, uniqueId, timestamp, vendorUrl, and product_id.
 */
import { useState } from "react";
import api from "../api/api";
import unixTimestamp from "../utils/unixTimestamp";
import getCountry from "../utils/getCountryCode";

const useInitializeSession = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState({ show: false, level: 1 });
  const [uniqueId, setUniqueId] = useState(null);
  const [vendorUrl, setVendorUrl] = useState(null);
  const [productId, setProductId] = useState(null);
  const [loading, setLoading] = useState(false);

  const initializeSession = async (product_id, href, reference) => {
    setVendorUrl(href);
    setProductId(product_id);
    const url = "/session_setup";
    let uniqueId = Math.floor(Math.random() * 1e10)
      .toString()
      .padStart(10, "0");
    if (reference !== null) {
      uniqueId = `${uniqueId}-${reference}`;
    };
    
    setUniqueId(uniqueId);
    const requestData = {
      product_id: product_id,
      session_id: uniqueId,
      session_info: {
        country: getCountry(),
        // device_brand: "Apple",
        // device_type: "Mobile",
        // ipv4: "88.88.88.88",
        // ipv6: "2000:0000:130F:0000:0000:09C0:876A:130A",
        // language: "en",
      },
      timestamp: unixTimestamp(),
      vendor_url: href,
    };

    try {
      setLoading(true);
      const res = await api.post(url, requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setResponse(res.data);
      if (res.data) {
        setShowModal({ ...showModal, show: true });
      }
    } catch (err) {
      if (err.response) {
        setError(err.response.data);
      } else {
        setError({ message: err.message });
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    initializeSession,
    response,
    error,
    showModal,
    setShowModal,
    uniqueId,
    vendorUrl,
    product_id: productId,
    loading,
  };
};

export default useInitializeSession;
